import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPeopleGroup } from '@fortawesome/pro-duotone-svg-icons';
import HeaderComponent from './HeaderComponent';
import BreadCrumbs from './BreadCrumbs';
import FeatureNav from './FeatureNav';
import FooterSection from './FooterSection';
import EmployeeSearch from "../assets/images/employee_search.svg";
import HighestPaidEmployee from "../assets/images/highest_paid_employees.svg";
import EntityCompensation from "../assets/images/entity_compensation.svg";
import '../assets/styles/main.css';

const EmployeePages = () => {
  return (
    <div className="employee-pages" id="employee-pages">
      <HeaderComponent/>
      <FeatureNav />
      <BreadCrumbs/>
      <section className="mt-20">
        <div className="text-center mb-4">
          <h1 className="display-5 fw-bold mb-3">Employees</h1>
        </div>

        <div className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0" style={{ backgroundColor: "var(--tu-teal)"}}>
          <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px"}}>
            <h3 className="text-light">
              <FontAwesomeIcon icon={faPeopleGroup} className="me-2" />
              Employee Compensation
            </h3>
            <p className="lead">Use these tools to search State and Local Government compensation.</p>
          </div>

          <div className="col-12 bg-light ">
            <div className="row justify-content-center px-3">
              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank" 
                rel="noopener noreferrer" href="/employees/employee-search" title=" Employee Search">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Employee Pay Search</div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={EmployeeSearch}
                  data-holder-rendered="true" 
                  />
                  <div className="card-body py-0">
                  <p className="card-text text-center">Search for an employee's compensation</p>
                  </div>
                </a>
              </article>

              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank" 
                rel="noopener noreferrer" href="/employees/highest-paid-employees" title="Highest Paid Employees">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Highest Paid Employees</div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={HighestPaidEmployee}
                  data-holder-rendered="true"/>
                  <div className="card-body py-0">
                  <p className="card-text text-center">Examine an Entity's highest paid employees</p>
                  </div>
                </a>
              </article>

              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank" 
                rel="noopener noreferrer" href="/entities/compensation-downloader" title="Compensation Downloader">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Compensation Downloader</div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={EntityCompensation}
                  data-holder-rendered="true"/>
                  <div className="card-body py-0">
                  <p className="card-text text-center">Download ALL of an entity's compensation data</p>
                  </div>
                </a>
              </article>
            </div>
          </div>
        </div>
      </section>
      <FooterSection />
    </div>
  )
}

export default EmployeePages;